module.exports = __webpack_public_path__ + "img/furnitureshop-banner-02.2f46457c.png";